import MobileConfirmModal from 'components/GlobalModals/MobileConfirmModal/MobileConfirmModal';
import { withMobileConfirmModalProps } from 'viewModel/globalModals/mobileConfirmModal/withMobileConfirmModalProps';

const ConnectedMobileConfirmModal = withMobileConfirmModalProps(MobileConfirmModal);

export default ConnectedMobileConfirmModal;
